import { useTranslation } from 'next-i18next';
import React from 'react';
import { fetchAndSetBoothLikesCount, fetchAndSetFavouriteBooths } from '../../../../../reduxToolkit/slices/commonSlice';
import { useSelector, useDispatch } from '../../../../../reduxToolkit/typedRedux';
import { addFavouriteBooth, deleteFavouriteBooth } from '../../../../../services/services';
import VyTooltip from '../../../../common/VyTooltip';
import { FavoriteStarIcon } from '../FavoriteIcon';

const BoothLikeButton = ({ boothid }: { boothid: string }) => {
  const booths = useSelector((state) => state.common.booths);
  const event = useSelector(({ common }) => common.event);
  const favouriteBooths = useSelector(({ common }) => common.favouriteBooths);
  const boothLikesCount = useSelector(({ common }) => common.boothLikesCount);
  const { t } = useTranslation('event');

  const dispatch = useDispatch();

  // we use this instead of directly passing the booth object because booth is set via routeChange listener inside OpenBooth.tsx
  // and the listener is not affected by the booths redux state changes and will always return the same content
  const currentBooth = booths.find((b) => b._id === boothid);

  if (!currentBooth) return null;

  async function likeBooth() {
    if (event && currentBooth) {
      await addFavouriteBooth(currentBooth?._id);
      dispatch(fetchAndSetFavouriteBooths(event?._id));
      dispatch(fetchAndSetBoothLikesCount(event?._id));
    }
  }

  async function dislikeBooth(favouriteId: string) {
    if (event) {
      await deleteFavouriteBooth(favouriteId);
      dispatch(fetchAndSetFavouriteBooths(event?._id));
      dispatch(fetchAndSetBoothLikesCount(event?._id));
    }
  }

  const showLikesCounter = currentBooth.settings?.showLikesCounter?.value;

  if (!currentBooth.settings?.showLikeInEventHome?.value && !showLikesCounter) return null;

  const favourite = favouriteBooths.find((f) => f.booth?._id === boothid);
  const likesCount = boothLikesCount?.find((likesCount) => likesCount.booth === currentBooth._id)?.count;
  const showTooltip = () => {
    if (currentBooth?.settings?.showLikeInEventHome.value && currentBooth?.settings?.showLikesCounter.value) return t('event:like-add-to-my-agenda');
    if (currentBooth?.settings?.showLikeInEventHome.value && !currentBooth?.settings?.showLikesCounter.value) return t('event:add-to-my-agenda');
    return t('event:like');
  };
  return (
    <div className="flex flex-col items-center justify-center">
      <VyTooltip title={showTooltip()}>
        {favourite ? (
          <div className="cursor-pointer" onClick={() => dislikeBooth(favourite._id)}>
            <FavoriteStarIcon isActive />
          </div>
        ) : (
          <div className="cursor-pointer" onClick={likeBooth}>
            <FavoriteStarIcon />
          </div>
        )}
      </VyTooltip>
      {showLikesCounter && <> {likesCount || 0}</>}
    </div>
  );
};

export default BoothLikeButton;
